module.exports = __webpack_public_path__ + "static/media/(000027).f5ebdfc8.jpg";